var _Path, _Path2, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgHeartRate(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#heart-rate_svg__clip0_7906_32619)",
    stroke: props.color,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M1.484 29.398h12.268l3.067-4.28 4.096 6.426 5.104-10.716 4.096 14.995 3.067-6.425h15.334"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M43.915 25.119a25.914 25.914 0 002.553-10.55c0-16.476-19.055-17.75-21.469-1.274C22.577-3.182 3.521-1.907 3.521 15.834a25.442 25.442 0 001.87 9.326M10.13 33.679a69.11 69.11 0 0014.84 14.767 87.32 87.32 0 0013.85-14.767"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "heart-rate_svg__clip0_7906_32619"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h50v50H0z"
  })))));
}

export default SvgHeartRate;